import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import {
    IOnboardingEditItem,
    IOnboardingStep,
    IOnboardingSyncCondition,
    ISyncOnboarding,
} from '../../../fi-onboarding';
import {
    FiSourceOnboardingStepConditionType,
    FiTargetOnboardingStepActionType,
} from '@fi-app/fi-onboarding/fi-onboarding-enums';
import { isDefined } from '@fi-shared/utils';

interface IFiConditionalLogicConditionEditorDialogData {
    condition: IOnboardingSyncCondition;
    selectedOnboardings: IOnboardingEditItem[]; // the same onboardings as in the editor tab
}

@Component({
    selector: 'fi-condition-editor-dialog',
    templateUrl: './fi-condition-editor-dialog.component.html',
    styleUrls: ['./fi-condition-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-condition-editor-dialog' },
    standalone: false,
})
export class FiConditionalLogicConditionEditorDialogComponent
    extends FiDialogsContentBase<IFiConditionalLogicConditionEditorDialogData, IOnboardingSyncCondition>
    implements OnInit
{
    protected condition: IOnboardingSyncCondition = this.data.condition;

    protected sourceOnboardingId: number;
    protected targetOnboardingId: number;

    ngOnInit() {
        this.sourceOnboardingId = this.findOnboardingIdByStepId(this.condition.SourceOnboardingStepId);
        this.targetOnboardingId = this.findOnboardingIdByStepId(this.condition.TargetOnboardingStepId);
    }

    private findOnboardingIdByStepId(stepId: number): number {
        // todo move to helper?
        const foundOnboarding = this.data.selectedOnboardings.find((onboarding) => {
            return !!onboarding.Sections.find((section) => {
                return !!section.Steps.find((step) => {
                    return step.Id === stepId;
                });
            });
        });
        return foundOnboarding?.Id;
    }

    protected getSourceOnboardingSteps(): IOnboardingStep[] {
        return (
            this.data.selectedOnboardings
                .find((onboarding) => onboarding.Id === this.sourceOnboardingId)
                ?.Sections.flatMap((section) => section.Steps) || []
        );
    }

    protected getTargetOnboardingSteps(): IOnboardingStep[] {
        return (
            this.data.selectedOnboardings
                .find((onboarding) => onboarding.Id === this.targetOnboardingId)
                ?.Sections.flatMap((section) => section.Steps) || []
        );
    }

    getResult(): IOnboardingSyncCondition {
        return this.condition;
    }

    protected readonly FiSourceOnboardingStepConditionType = FiSourceOnboardingStepConditionType;
    protected readonly FiTargetOnboardingStepActionType = FiTargetOnboardingStepActionType;
}
